<!--
Author: TangChen
Date: 2018-10-17
Desc: 找回登录密码，由index.js 配置引入
 -->
<template>
    <div class="bizcomp-reset-lpwd">
        <reset-pwd :way="way" />
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import resetPwd from "@/components/acctInfo/resetPwdDc.vue";
export default {
    name: "Resetlpwd",
    components: {
        resetPwd
    },
    mixins: [mixin],
    data() {
        return {
            way: "login"
        };
    },
    methods: {
        // 账户绑定选项处理
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.bizcomp-reset-lpwd {
    margin-top: 20px;
}
</style>
